import requestJson from '@/utils/requestJson'

// 保存用户登录信息
export function userLogin(data) {
  return requestJson({
    url: '/login/userGoLogin',
    method: 'POST',
    data: data // 它是直接把参数转成JSON放在BODY中
  })
}

//获取会议列表
export function QueryActives() {
  return requestJson({
    url: `/active/user/queryActives`,
    method: 'GET'
  })
}

//查找会议详情
export function queryByIdActive(id) {
  return requestJson({
    url: `/active/user/queryByIdActive?id=${id}`,
    method: 'get',
  })
}

// 用户表单填写
export function addUserForm(data) {
  return requestJson({
    url: '/userForm/user/addUserForm',
    method: 'POST',
    data: data // 它是直接把参数转成JSON放在BODY中
  })
}


export function authorize(openId) {
  return requestJson({
    url: `/authorize?openId=${openId}`,
    method: 'POST',
  })
}

export function prizeLifeSciences(data) {
  return requestJson({
    url: `/prize_life_sciences`,
    method: 'POST',
    data
  })
}




